import { render, staticRenderFns } from "./ksIDTable.vue?vue&type=template&id=08bef998"
import script from "./ksIDTable.vue?vue&type=script&lang=js"
export * from "./ksIDTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports